import { Outlet, useLocation, useNavigation, useOutlet } from 'react-router-dom';
import { CLottie, PageTitle } from 'components/atoms';
import { CDialog, Footer, Header, SidebarNavigation } from 'components/molecules';
import { useAppContext } from 'hooks/context';
import { useEffect, useRef } from 'react';
import { Drawer } from '@mui/material';
import { useAppDispatch, useAppSelector } from 'hooks/redux';
import { setSidebarOpen } from 'store/app/app-slice';
import { VideoCall } from 'components/organisms';
import { CDialogProps } from 'types/molecules';

const ProtectedLayout = () => {
  console.log('ProtectedLayout');
  const jitsiRef = useRef<CDialogProps['jitsiRef']>();
  const { state } = useNavigation();
  const { pathname } = useLocation();
  const { isSidebarOpen, isPageTitleVisible, videoCall } = useAppSelector((state) => state.app);
  const dispatch = useAppDispatch();
  const outletData = useOutlet();
  const { title, titleChildren } =
    outletData?.props?.children?.props?.children?.props?.children?.props?.children?.props ??
    outletData?.props?.children?.props?.children?.props?.children?.props ??
    outletData?.props?.children?.props?.children?.props ??
    {};

  const {
    dialog: { showDialog },
  } = useAppContext();

  useEffect(() => {
    if (isSidebarOpen) {
      dispatch(setSidebarOpen(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  // useEffect(() => {
  //   showDialog({
  //     message: t('pet.ask-register'),
  //     onClose: () => null,
  //     onApprove: () => {
  //       navigate('/');
  //     },
  //     onApproveTitle: `${t('pet.add')}*`,
  //   });
  // }, []);

  return (
    <div className="flex h-screen max-w-full gap-6 md:overflow-hidden">
      <Drawer
        variant="temporary"
        anchor="left"
        open={isSidebarOpen}
        onClose={() => dispatch(setSidebarOpen(false))}
        ModalProps={{
          keepMounted: true, // Better open performance on mobile.
        }}
        classes={{ paper: 'rounded-r-[30px]' }}
      >
        <SidebarNavigation className="flex h-full" />
      </Drawer>
      <SidebarNavigation className="hidden lg:flex" />
      <div className="flex min-h-screen w-[calc(100%-240px-24px)] flex-1 flex-col md:h-screen">
        <Header className="fixed z-10 md:static" />

        <main className="mx-2 my-4 mt-[96px] flex flex-1 flex-col sm:mx-4 md:mt-4 md:overflow-y-auto lg:mx-6 lg:ml-0">
          {state === 'loading' ? (
            <CLottie isFullPage />
          ) : (
            <>
              {title && isPageTitleVisible && (
                <PageTitle title={title}>{titleChildren ?? null}</PageTitle>
              )}

              <Outlet />
            </>
          )}
        </main>

        <Footer />
      </div>

      <CDialog
        open={videoCall?.isShow}
        isDraggable={videoCall?.screen.isDraggable}
        title={videoCall.isDoctorAttended ? videoCall?.doctorName || 'VetAmerikan' : ''}
        isFullScreen={videoCall?.screen.isFullScreen}
        isCentred={videoCall?.screen.isCentred}
        jitsiRef={
          jitsiRef.current
            ? {
                close: () => jitsiRef.current?.close && jitsiRef.current.close(),
                minimize: () => jitsiRef.current?.minimize && jitsiRef.current.minimize(),
                fullScreen: () => jitsiRef.current?.fullScreen && jitsiRef.current.fullScreen(),
              }
            : undefined
        }
      >
        <VideoCall jitsiRef={jitsiRef} />
      </CDialog>
    </div>
  );
};

export default ProtectedLayout;

